import React from 'react';
import { formatValue } from '../utils/formatters';

const FormDetailsModal = ({ isOpen, onClose, form }) => {
    if (!isOpen || !form) {
        return null;
    }

    const fields = form.fields || [];
    const requiredFields = fields.filter(f => f.required);
    const visibleFields = fields.filter(f => f.type !== 'hidden');
    const hiddenFields = fields.filter(f => f.type === 'hidden');

    return (
        <div
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(7, 7, 10, 0.92)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 10000,
                padding: '24px'
            }}
            onClick={onClose}
        >
            <div
                style={{
                    position: 'relative',
                    width: '100%',
                    maxWidth: '1200px',
                    maxHeight: '90vh',
                    backgroundColor: '#121212',
                    borderRadius: '10px',
                    boxShadow: '0 18px 60px rgba(0, 0, 0, 0.55)',
                    border: '1px solid rgba(100, 181, 246, 0.35)',
                    overflow: 'hidden',
                    display: 'flex',
                    flexDirection: 'column'
                }}
                onClick={(e) => e.stopPropagation()}
            >
                <button
                    onClick={onClose}
                    style={{
                        position: 'absolute',
                        top: '14px',
                        right: '14px',
                        backgroundColor: 'rgba(220, 53, 69, 0.92)',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '50%',
                        width: '42px',
                        height: '42px',
                        fontSize: '24px',
                        cursor: 'pointer',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        fontWeight: 'bold',
                        boxShadow: '0 8px 20px rgba(220, 53, 69, 0.45)',
                        transition: 'transform 0.2s ease, background-color 0.2s ease',
                        zIndex: 1
                    }}
                    onMouseEnter={(e) => {
                        e.target.style.backgroundColor = 'rgba(207, 46, 60, 0.95)';
                        e.target.style.transform = 'scale(1.05)';
                    }}
                    onMouseLeave={(e) => {
                        e.target.style.backgroundColor = 'rgba(220, 53, 69, 0.92)';
                        e.target.style.transform = 'scale(1)';
                    }}
                >
                    ×
                </button>
                <div
                    style={{
                        flex: 1,
                        overflow: 'auto',
                        backgroundColor: '#0c0c0c',
                        padding: '24px'
                    }}
                >
                    <h3
                        style={{
                            margin: '0 0 24px 0',
                            color: '#e0e0e0',
                            fontWeight: '600'
                        }}
                    >
                        Form Details
                    </h3>

                    {/* Form URL */}
                    <div style={{ marginBottom: '24px' }}>
                        <div style={{
                            fontSize: '12px',
                            color: '#909090',
                            textTransform: 'uppercase',
                            marginBottom: '8px',
                            fontWeight: '600',
                            letterSpacing: '0.5px'
                        }}>
                            URL
                        </div>
                        <a
                            href={form.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                                color: '#60a5fa',
                                textDecoration: 'none',
                                fontSize: '14px',
                                wordBreak: 'break-all',
                                display: 'block'
                            }}
                            onMouseEnter={(e) => e.target.style.textDecoration = 'underline'}
                            onMouseLeave={(e) => e.target.style.textDecoration = 'none'}
                        >
                            {form.url}
                        </a>
                    </div>

                    {/* Form Info */}
                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                        gap: '16px',
                        marginBottom: '24px'
                    }}>
                        {form.form_type && (
                            <div style={{
                                backgroundColor: '#181818',
                                border: '1px solid rgba(100, 181, 246, 0.12)',
                                borderRadius: '8px',
                                padding: '12px'
                            }}>
                                <div style={{
                                    fontSize: '11px',
                                    color: '#909090',
                                    textTransform: 'uppercase',
                                    marginBottom: '6px',
                                    fontWeight: '600',
                                    letterSpacing: '0.5px'
                                }}>
                                    Form Type
                                </div>
                                <div style={{
                                    fontSize: '14px',
                                    color: '#e0e0e0',
                                    fontWeight: '500'
                                }}>
                                    {formatValue(form.form_type)}
                                </div>
                            </div>
                        )}
                        {form.method && (
                            <div style={{
                                backgroundColor: '#181818',
                                border: '1px solid rgba(100, 181, 246, 0.12)',
                                borderRadius: '8px',
                                padding: '12px'
                            }}>
                                <div style={{
                                    fontSize: '11px',
                                    color: '#909090',
                                    textTransform: 'uppercase',
                                    marginBottom: '6px',
                                    fontWeight: '600',
                                    letterSpacing: '0.5px'
                                }}>
                                    Method
                                </div>
                                <div style={{
                                    fontSize: '14px',
                                    color: '#e0e0e0',
                                    fontWeight: '500',
                                    textTransform: 'uppercase'
                                }}>
                                    {form.method}
                                </div>
                            </div>
                        )}
                        {form.action && (
                            <div style={{
                                backgroundColor: '#181818',
                                border: '1px solid rgba(100, 181, 246, 0.12)',
                                borderRadius: '8px',
                                padding: '12px'
                            }}>
                                <div style={{
                                    fontSize: '11px',
                                    color: '#909090',
                                    textTransform: 'uppercase',
                                    marginBottom: '6px',
                                    fontWeight: '600',
                                    letterSpacing: '0.5px'
                                }}>
                                    Action
                                </div>
                                <div style={{
                                    fontSize: '14px',
                                    color: '#e0e0e0',
                                    fontWeight: '500',
                                    wordBreak: 'break-all'
                                }}>
                                    {form.action}
                                </div>
                            </div>
                        )}
                        {form.page_hash && (
                            <div style={{
                                backgroundColor: '#181818',
                                border: '1px solid rgba(100, 181, 246, 0.12)',
                                borderRadius: '8px',
                                padding: '12px'
                            }}>
                                <div style={{
                                    fontSize: '11px',
                                    color: '#909090',
                                    textTransform: 'uppercase',
                                    marginBottom: '6px',
                                    fontWeight: '600',
                                    letterSpacing: '0.5px'
                                }}>
                                    Page Hash
                                </div>
                                <div style={{
                                    fontSize: '12px',
                                    color: '#a0a0a0',
                                    fontFamily: 'monospace',
                                    wordBreak: 'break-all'
                                }}>
                                    {form.page_hash}
                                </div>
                            </div>
                        )}
                    </div>

                    {/* Summary Stats */}
                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
                        gap: '12px',
                        marginBottom: '24px'
                    }}>
                        <div style={{
                            backgroundColor: '#181818',
                            border: '1px solid rgba(100, 181, 246, 0.12)',
                            borderRadius: '8px',
                            padding: '12px',
                            textAlign: 'center'
                        }}>
                            <div style={{
                                fontSize: '11px',
                                color: '#909090',
                                textTransform: 'uppercase',
                                marginBottom: '6px',
                                fontWeight: '600',
                                letterSpacing: '0.5px'
                            }}>
                                Total Fields
                            </div>
                            <div style={{
                                fontSize: '24px',
                                color: '#60a5fa',
                                fontWeight: '700'
                            }}>
                                {fields.length}
                            </div>
                        </div>
                        <div style={{
                            backgroundColor: '#181818',
                            border: '1px solid rgba(100, 181, 246, 0.12)',
                            borderRadius: '8px',
                            padding: '12px',
                            textAlign: 'center'
                        }}>
                            <div style={{
                                fontSize: '11px',
                                color: '#909090',
                                textTransform: 'uppercase',
                                marginBottom: '6px',
                                fontWeight: '600',
                                letterSpacing: '0.5px'
                            }}>
                                Required
                            </div>
                            <div style={{
                                fontSize: '24px',
                                color: '#fbbf24',
                                fontWeight: '700'
                            }}>
                                {requiredFields.length}
                            </div>
                        </div>
                        <div style={{
                            backgroundColor: '#181818',
                            border: '1px solid rgba(100, 181, 246, 0.12)',
                            borderRadius: '8px',
                            padding: '12px',
                            textAlign: 'center'
                        }}>
                            <div style={{
                                fontSize: '11px',
                                color: '#909090',
                                textTransform: 'uppercase',
                                marginBottom: '6px',
                                fontWeight: '600',
                                letterSpacing: '0.5px'
                            }}>
                                Visible
                            </div>
                            <div style={{
                                fontSize: '24px',
                                color: '#34d399',
                                fontWeight: '700'
                            }}>
                                {visibleFields.length}
                            </div>
                        </div>
                        <div style={{
                            backgroundColor: '#181818',
                            border: '1px solid rgba(100, 181, 246, 0.12)',
                            borderRadius: '8px',
                            padding: '12px',
                            textAlign: 'center'
                        }}>
                            <div style={{
                                fontSize: '11px',
                                color: '#909090',
                                textTransform: 'uppercase',
                                marginBottom: '6px',
                                fontWeight: '600',
                                letterSpacing: '0.5px'
                            }}>
                                Hidden
                            </div>
                            <div style={{
                                fontSize: '24px',
                                color: '#9ca3af',
                                fontWeight: '700'
                            }}>
                                {hiddenFields.length}
                            </div>
                        </div>
                    </div>

                    {/* Fields */}
                    <div style={{ marginBottom: '24px' }}>
                        <h4 style={{
                            margin: '0 0 16px 0',
                            color: '#e0e0e0',
                            fontWeight: '600',
                            fontSize: '16px'
                        }}>
                            Fields ({fields.length})
                        </h4>
                        <div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '12px'
                        }}>
                            {fields.map((field, index) => (
                                <div
                                    key={index}
                                    style={{
                                        backgroundColor: '#181818',
                                        border: '1px solid rgba(100, 181, 246, 0.12)',
                                        borderRadius: '8px',
                                        padding: '16px'
                                    }}
                                >
                                    <div style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'flex-start',
                                        marginBottom: '12px',
                                        flexWrap: 'wrap',
                                        gap: '8px'
                                    }}>
                                        <div style={{ flex: 1, minWidth: 0 }}>
                                            <div style={{
                                                fontSize: '14px',
                                                fontWeight: '600',
                                                color: '#e0e0e0',
                                                marginBottom: '4px'
                                            }}>
                                                {field.label || field.name || `Field ${index + 1}`}
                                                {field.required && (
                                                    <span style={{
                                                        color: '#f87171',
                                                        marginLeft: '6px',
                                                        fontSize: '12px'
                                                    }}>
                                                        *
                                                    </span>
                                                )}
                                            </div>
                                            {field.name && (
                                                <div style={{
                                                    fontSize: '12px',
                                                    color: '#909090',
                                                    fontFamily: 'monospace',
                                                    marginBottom: '4px'
                                                }}>
                                                    name: {field.name}
                                                </div>
                                            )}
                                        </div>
                                        <div style={{
                                            display: 'flex',
                                            gap: '8px',
                                            flexWrap: 'wrap'
                                        }}>
                                            {field.type && (
                                                <span style={{
                                                    display: 'inline-block',
                                                    backgroundColor: '#1e3a5f',
                                                    color: '#60a5fa',
                                                    padding: '4px 10px',
                                                    borderRadius: '12px',
                                                    fontSize: '11px',
                                                    fontWeight: '500'
                                                }}>
                                                    {field.type}
                                                </span>
                                            )}
                                            {field.tag && (
                                                <span style={{
                                                    display: 'inline-block',
                                                    backgroundColor: '#2d2d2d',
                                                    color: '#e0e0e0',
                                                    padding: '4px 10px',
                                                    borderRadius: '12px',
                                                    fontSize: '11px',
                                                    fontWeight: '500'
                                                }}>
                                                    {field.tag}
                                                </span>
                                            )}
                                            {field.required && (
                                                <span style={{
                                                    display: 'inline-block',
                                                    backgroundColor: 'rgba(239, 68, 68, 0.15)',
                                                    color: '#f87171',
                                                    padding: '4px 10px',
                                                    borderRadius: '12px',
                                                    fontSize: '11px',
                                                    fontWeight: '500'
                                                }}>
                                                    Required
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                    <div style={{
                                        display: 'grid',
                                        gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                                        gap: '8px',
                                        fontSize: '12px',
                                        color: '#a0a0a0'
                                    }}>
                                        {field.id && (
                                            <div>
                                                <span style={{ color: '#909090' }}>ID: </span>
                                                <span style={{ fontFamily: 'monospace' }}>{field.id}</span>
                                            </div>
                                        )}
                                        {field.placeholder && (
                                            <div>
                                                <span style={{ color: '#909090' }}>Placeholder: </span>
                                                <span>{field.placeholder}</span>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            ))}
                        </div>
                        {fields.length === 0 && (
                            <div style={{
                                padding: '20px',
                                textAlign: 'center',
                                color: '#909090',
                                fontSize: '14px'
                            }}>
                                No fields found
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FormDetailsModal;

